module.exports = __webpack_public_path__ + "static/media/coin.24f5faf8.png";